import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { environment } from "environments/environment";

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy
{
    private readonly title = inject(Title);

    override updateTitle(routerState: RouterStateSnapshot) {
        const breadcrumbs = [];

        const siteTitle = environment.websiteTitle || environment.productTitle || '';
        if (siteTitle) {
            breadcrumbs.push(siteTitle);
        }

        const title = this.buildTitle(routerState);
        if (title) {
            breadcrumbs.push(title)
        }

        this.title.setTitle(breadcrumbs.join(' - '));
    }
}

// export const appConfig: ApplicationConfig = {
//     providers: [
//         provideRouter(routes),
//         { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
//     ]
// };
